module.exports = __webpack_public_path__ + "img/guide1.e929e3fa.png";